const actions = {
  GET_DATA_BEGIN: 'WAREHOUSE_REQUESTS_GET_DATA_BEGIN',
  GET_DATA_SUCCESS: 'WAREHOUSE_REQUESTS_GET_DATA_SUCCESS',
  GET_DATA_ERR: 'WAREHOUSE_REQUESTS_GET_DATA_ERR',
  SET_UPDATED: 'WAREHOUSE_REQUESTS_SET_UPDATED',
  SET_CURRENT: 'WAREHOUSE_REQUESTS_SET_CURRENT',

  getDataBegin: () => ({ type: actions.GET_DATA_BEGIN }),
  getDataSuccess: (data: any) => ({ type: actions.GET_DATA_SUCCESS, data }),
  getDataErr: (err: any) => ({ type: actions.GET_DATA_ERR, err }),
  setUpdated: (data: any) => ({ type: actions.SET_UPDATED, data }),
  setCurrent: (data: any) => ({ type: actions.SET_CURRENT, data }),
};

export default actions;
